import * as React from 'react'
import styled from 'styled-components'
import { BodyWithMenu } from '../../components/organisms/Menu'
import { getInvestorDashboard } from '../../globals/ApiHooks';
import { lang } from '../../globals/Translations';
import { TranslatedTerms } from '../../globals/TranslatedTerms';
import { Dashboard } from '../../shared/UI';
import { IsHorizontalMobile, useWindowSize } from '../../globals/UIHooks';
import {
  NewsBox, AccountBox, DASHBOARD_GAP, InvestmentPieChart, InvestementsTable, NotificationTable, BoxTemplate, BackgorundDashboardBox
} from '../../components/molecules/DashboardBoxes'
import { DefaultPersonalAccountId } from '../../shared/Globals';
import Investor, { Account } from '../../shared/Investor';
import { PostList } from '../Feed';
import AnalyticsHooks from '../../globals/AnalyticsHooks';
import { ActivityType } from '../../shared/Activity';


export const getAccountName = (account: Account, investor: Investor) => {
  if (account.accountId === DefaultPersonalAccountId) return (lang(DefaultPersonalAccountId) + ' - ' + investor.fname + ' ' + investor.lname)
  return (account.company ? lang(TranslatedTerms.COMPANY_ACCOUNT) : lang(DefaultPersonalAccountId)) + ' - ' + account.accountName
}

const DefaultGrid = styled.div`
  display: grid;
  grid-column-gap: ${DASHBOARD_GAP}px;
  grid-row-gap: ${DASHBOARD_GAP}px;
  margin-bottom: ${DASHBOARD_GAP}px;
  grid-template-columns: 1fr;
`

export const IndexPage: React.FC = () => {
  const [dashboard, setDashboard] = React.useState<Dashboard>()
  const [loading, setLoading] = React.useState(true)

  const { width } = useWindowSize()

  React.useEffect(() => {
    (async () => {
      setLoading(true)
      setDashboard(await getInvestorDashboard())
      setLoading(false)
    })()
  }, [])

  AnalyticsHooks.LogActivity(ActivityType.DASHBOARD_VISIT)
  return (
    <BodyWithMenu loading={loading}>
      <h1 style={{ margin: 0 }}>{lang(TranslatedTerms.HOME)}</h1>
      <DefaultGrid style={{ gridTemplateColumns: IsHorizontalMobile(width) ? "1fr" : "2fr 1fr" }}>
        <AccountBox lastInvestment={dashboard?.latestInvestmentWithProject} userAccountsValue={dashboard?.totalAccountValue} loading={loading} />
        <NewsBox />
      </DefaultGrid>
      <DefaultGrid style={{ width: '100%', flexDirection: 'column' }}>
        {dashboard && dashboard.investmentsGroupedByAccounts && <h2>{lang(TranslatedTerms.ACTIVE_INVESTMENTS)}</h2>}
        {dashboard && dashboard.investmentsGroupedByAccounts.map((item, key) => (
          <div key={key}>
            <BackgorundDashboardBox style={{ width: '100%', flexDirection: 'column' }}>
              <h3 style={{ margin: 0 }}>{getAccountName(item.account, dashboard.investor)}</h3>
              <InvestementsTable loading={loading} investments={item.investments} accountValue={item.accountValue} projects={dashboard.projects} />
            </BackgorundDashboardBox>
          </div>
        ))}
      </DefaultGrid>
      <DefaultGrid style={{ width: '100%', flexDirection: 'column' }}>
        {dashboard && dashboard.completedInvestmentsGroupedByAccounts && <h2>{lang(TranslatedTerms.PAID_BACK_INVESTMENTS)}</h2>}
        {dashboard && dashboard.completedInvestmentsGroupedByAccounts.map((item, key) => (
          <div key={key}>
            <BackgorundDashboardBox style={{ width: '100%', flexDirection: 'column' }}>
              <h3 style={{ margin: 0 }}>{getAccountName(item.account, dashboard.investor)}</h3>
              <InvestementsTable loading={loading} investments={item.investments} accountValue={item.accountValue} showActualReturn={true} projects={dashboard.projects} />
            </BackgorundDashboardBox>
          </div>
        ))}
      </DefaultGrid>

      <DefaultGrid>
        {dashboard && dashboard.dashboardNewsFeed && <h2>{lang(TranslatedTerms.PROJECT_NEWS)}</h2>}
        <PostList posts={(dashboard && dashboard.dashboardNewsFeed) || []} />
      </DefaultGrid>
    </BodyWithMenu>
  )
};
